import React from 'react';
import { Link } from 'react-router-dom';
import styles from './AppPage.module.css';

function FixscopePage() {
  return (
    <div className={styles.appPage}>
      <div className={`${styles.appHero} ${styles.fixscopeHero}`}>
        <div className={styles.heroContent}>
          <span className={styles.appIcon}>🔧</span>
          <h1>Fixscope</h1>
          <span className={`${styles.status} ${styles.inDevelopment}`}>IN DEVELOPMENT</span>
          <p className={styles.tagline}>
            AI-powered diagnostics for mechanical and electronic problems.
          </p>
        </div>
      </div>

      <section className={styles.section}>
        <h2>The Vision</h2>
        <p>
          Something's broken. You hear a weird noise, see an error code, or notice something
          isn't working right. What do you do? Search through forums? Watch dozens of YouTube
          videos? Call an expensive technician? Fixscope aims to be your first stop—an AI
          diagnostic tool that helps you understand what's wrong and how to fix it.
        </p>
      </section>

      <section className={styles.section}>
        <h2>How It Will Work</h2>
        <div className={styles.steps}>
          <div className={styles.step}>
            <span className={styles.stepNumber}>1</span>
            <h3>Describe</h3>
            <p>Tell the app what's happening—symptoms, sounds, error codes</p>
          </div>
          <div className={styles.step}>
            <span className={styles.stepNumber}>2</span>
            <h3>Capture</h3>
            <p>Take photos or videos of the problem area</p>
          </div>
          <div className={styles.step}>
            <span className={styles.stepNumber}>3</span>
            <h3>Diagnose</h3>
            <p>AI analyzes the information and suggests likely causes</p>
          </div>
          <div className={styles.step}>
            <span className={styles.stepNumber}>4</span>
            <h3>Fix</h3>
            <p>Get step-by-step repair guidance and parts info</p>
          </div>
        </div>
      </section>

      <section className={styles.section}>
        <h2>Planned Features</h2>
        <ul className={styles.featureList}>
          <li>
            <strong>AI-Driven Diagnosis</strong>
            <span>Intelligent analysis of mechanical and electronic issues</span>
          </li>
          <li>
            <strong>Visual Recognition</strong>
            <span>Identify parts and problems from photos</span>
          </li>
          <li>
            <strong>Step-by-Step Guidance</strong>
            <span>Detailed repair instructions tailored to your skill level</span>
          </li>
          <li>
            <strong>Parts Identification</strong>
            <span>Know exactly what parts you need and where to find them</span>
          </li>
          <li>
            <strong>Error Code Database</strong>
            <span>Comprehensive lookup for appliance and vehicle codes</span>
          </li>
          <li>
            <strong>Professional Mode</strong>
            <span>Advanced features for technicians and mechanics</span>
          </li>
        </ul>
      </section>

      <section className={styles.section}>
        <h2>Who It's For</h2>
        <div className={styles.useCards}>
          <div className={styles.useCard}>
            <h3>DIY Enthusiasts</h3>
            <p>Fix things yourself with confidence</p>
          </div>
          <div className={styles.useCard}>
            <h3>Homeowners</h3>
            <p>Diagnose appliance and home system issues</p>
          </div>
          <div className={styles.useCard}>
            <h3>Professionals</h3>
            <p>Quick reference tool for mechanics and technicians</p>
          </div>
        </div>
      </section>

      <section className={`${styles.ctaSection} ${styles.developmentCta}`}>
        <h2>In Development</h2>
        <p>
          Fixscope is currently being built. We're working hard to create a tool that
          actually helps you fix things, not just tells you to "call a professional."
        </p>
        <div className={styles.progressBar}>
          <div className={styles.progressFill} style={{ width: '35%' }}></div>
        </div>
        <p className={styles.progressText}>Development Progress</p>
      </section>

      <div className={styles.backLink}>
        <Link to="/">← Back to Home</Link>
      </div>
    </div>
  );
}

export default FixscopePage;
